<template>
    <div>

        <div>
            <ModuleHeader title="Eingangsrechnung erstellen">

            </ModuleHeader>

            <div class="loading" v-if="!customers && !projects && !error">

            </div>

            <div v-if="error" class="error">
                <div class="mb-4">{{ error }}</div>
                <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
            </div>

            <div v-if="saveError" class="error">
                <div class="mb-4">{{ saveError }}</div>
                <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
            </div>


            <div v-if="customers && projects && !saveError && !error">
                <form @submit.prevent="createInvoice" class="center-form default-form">
                    <div class="form-group">
                        <label for="invoiceNumber">Rechnungsnummer</label>

                        <b-form-input id="invoiceNumber"
                                      autocomplete="off"
                                      :state="checkState('invoiceNumber')"
                                      type="text"
                                      v-validate="'required'"
                                      name="invoiceNumber"
                                      v-model.trim="invoice.number"
                        ></b-form-input>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label>Kunde</label>

                            <b-form-select v-model="invoice.customerId"
                                           :options="customers"
                                           :state="checkState('customerId')"
                                           name="customerId"
                                           v-validate="'required'"/>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Projekt</label>

                            <b-form-select v-model="invoice.projectId"
                                           :options="projects.filter(x => x.customerId === invoice.customerId)"
                                           :state="checkState('projectId')"
                                           name="projectId"
                                           v-validate="'required'"/>
                        </div>
                    </div>

                    <div class="form-row mt-3">
                        <div class="d-flex align-items-center col">
                            <div class="upload-btn-wrapper">
                                <button class="btn btn-primary" type="button">Datei auswählen</button>
                                <input type="file" @change="uploadFile($event.target.files)">
                            </div>
                            <div v-if="file"><span class="text-exposed text-darker ml-3">{{file.name}}</span></div>
                        </div>
                        <div v-show="errorFileNotSelected" class="col-12 error-message mt-1">Zuerst eine Datei auswählen.</div>
                    </div>

                    <div class="form-row mt-2" :style="{opacity: progressOpacity}">
                        <b-progress class="w-100" :value="progressUpload" :max="max" show-progress></b-progress>
                    </div>

                    <div class="buttons d-flex justify-content-between mt-5">
                        <div><button type="submit" class="btn btn-success">Erstellen</button></div>
                        <button type="button" class="btn btn-primary" @click="$router.go(-1)">Abbrechen</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import ModuleHeader from "components/util/ModuleHeader";
    import firebase from 'firebase/app';
    require ('firebase/storage');
    import firestore from 'firedb/init';
    import firedb from 'firedb/db';

    export default {
        name: "DocumentDashboard",
        components: {ModuleHeader, Datepicker},

        data: () => {
            return {

                progressUpload: 0,
                max: 100,
                uploadTask: null,
                customers: null,
                projects: null,
                invoice: {
                    number: null, //https://vuejs.org/2016/02/06/common-gotchas/ Why isn’t the DOM updating? 1
                    project: null,
                    customer: null,
                    customerId: null,
                    projectId: null
                },
                saveError: null,
                error: null,
                file: null,
                progressOpacity: 0,
                errorFileNotSelected: null
            }
        },
        methods: {

            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            },

            uploadFile(files) {

                this.file = files[0];

                if (this.file) {
                    this.errorFileNotSelected = null;
                }
            },

            createInvoice() {

                if (this.file) {
                    this.errorFileNotSelected = null;
                } else {
                    this.errorFileNotSelected = 'Zuerst eine Datei auswählen';
                }

                this.$validator.validateAll().then(valid => {

                    if (valid && this.file) {

                        this.progressOpacity = 1;
                        this.uploadTask = firebase.storage().ref(`incoming-invoices/${this.invoice.customerId}-${this.invoice.number}.${this.file.name.split('.').pop()}`).put(this.file);
                    }
                });
            },

            createDatabaseEntry(downloadURL) {

                this.invoice.customer = this.customers.filter(x => x.id === this.invoice.customerId)[0].name;
                this.invoice.project = this.projects.filter(x => x.id === this.invoice.projectId)[0].name;

                firedb.create('documents', {
                    downloadURL,
                    invoice: this.invoice,
                    originalFileName: this.file.name
                }).then(result => {
                    //this.$router.replace({name: 'DocumentDashboard'});
                }).catch(e => {
                    console.error(e);
                    this.saveError = "Eingangsrechnung konnte nicht erstellt werden."
                });
            }
        },

        watch: {
            uploadTask: function() {
                this.uploadTask.on('state_changed', sp => {
                        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
                    },
                    (err) => {
                        console.log(err);
                    },
                    () => {
                        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                            //this.$emit('url', downloadURL)
                            this.createDatabaseEntry(downloadURL);
                        })
                    })
            }
        },

        created() {

            //TODO change to Promise.all
            firestore.collection('customer').get()
                .then(snapshot => {

                    if (snapshot.size === 0) {
                        return Promise.reject('Keine Kunden gefunden');
                    }

                    this.customers = [];

                    snapshot.forEach(doc => {
                        let customer = doc.data();
                        customer.id = doc.id;
                        customer.value = customer.id; //for bootstrap combo
                        customer.text = customer.name; //for bootstrap combo

                        this.customers.push(customer);
                    });
                })
                .then(() => {

                    return firestore.collection('project').get()
                        .then(snapshot => {

                            if (snapshot.size === 0) {
                                return Promise.reject('Keine Projekte gefunden');
                            }

                            this.projects = [];

                            snapshot.forEach(doc => {
                                let project = doc.data();
                                project.id = doc.id;
                                project.value = project.id; //for bootstrap combo
                                project.text = project.name; //for bootstrap combo

                                this.projects.push(project);
                            });
                        });
                })
                .catch((e) => {
                    console.error(e);
                    this.error = 'Für die Erstelleung einer Rechnung notwendige Daten konnten nicht geladen werden.'
                });
        }
    }
</script>

<style scoped lang="scss">

    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }

    .upload-btn-wrapper:hover {
        cursor: pointer !important;
    }
    .upload-btn-wrapper:hover > .btn {
        background-color: darken(#007bff, 5%);
        cursor: pointer;
    }

    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }

</style>